// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"321342fa","787":"81b0d8ea","998":"fc138a19"}[chunkId] + ".chunk.js";
};